module.exports = __webpack_public_path__ + "img/crypto-usd.c09801e2.svg";